import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import PrivateCleaning from './pages/PrivateCleaning';
import CommercialCleaning from './pages/CommercialCleaning';
import CalculatorPage from './pages/CalculatorPage';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privat-rengoering" element={<PrivateCleaning />} />
            <Route path="/erhvervsrengoering" element={<CommercialCleaning />} />
            <Route path="/prisberegner" element={<CalculatorPage />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
